<template>
  <div
    class="progress mt-1"
    :style="{ height}"
  >
    <div
      class="progress-bar"
      :class="{
        'progress-bar-animated': animated,
        'progress-bar-striped': striped,
        [`bg-${variant}`]: variant
      }"
      role="progressbar"
      aria-valuemin="0"
      :aria-valuemax="max"
      :aria-valuenow="value"
      :style="{ width }"
    />
  </div>
</template>

<script>

export default {
  name: 'BProgress',
  props: {
    height: {
      type: String,
      default: null
    },
    max: {
      type: Number,
      default: 100
    },
    value: {
      type: Number,
      default: 0
    },
    precision: {
      type: Number,
      default: 0
    },
    variant: {
      type: String,
      default: null
    },
    animated: Boolean,
    striped: Boolean
  },
  computed: {
    width() {
      return 100 * (this.value / this.max) + '%'
    }
  }
}
</script>
